import { Api } from 'models/services/api';
import { CreateBrandQuery } from 'models/services/graphql';

import { BrandData, BrandDataToSave } from '../index';

type DataToCreate = {
  input: BrandDataToSave;
};

const RequestQuery = `
  mutation CreateBrand($input: BrandInput!) {
    ${CreateBrandQuery}
  }
`;

type ResponseData = {
  data: {
    createBrand: BrandData
  }
}

class CreateGql {

  readonly api: Api<ResponseData>;
  readonly document?: BrandData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToCreate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.createBrand;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { CreateGql };